import React from 'react'
import { ModuleHeader } from '../module-header'
import { StyledFinishedExamsCardWrapper } from './scored-exams.style'
import ScoredExamsItem from './scored-exams-item'

const ScoredExams = ({ isAssignment }) => {
    const itemList = [1, 2, 3]
    return (
        <>
            <ModuleHeader title={!isAssignment ? "scored EXAMS" : "SCORED ASSIGNMENTS"} />
            <StyledFinishedExamsCardWrapper>
                {itemList.map(item => (
                    <ScoredExamsItem key={item} isAssignment={isAssignment} />
                ))}
            </StyledFinishedExamsCardWrapper>
        </>
    )
}

export { ScoredExams }
